export default __webpack_public_path__ + "static/media/SPLogo.494f5a13.svg";